export default "__VITE_ASSET__DOnkDoZ2__"